import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What is React used for?",
    answer: ` <p>React Native is used to build native cross-platform mobile apps for iOS and Android using a single codebase. This React Native cross-platform app development capability helps entrepreneurs cut their app development costs in half, reduce turnaround time for full-scale development, and make maintaining the app more accessible.</p>`,
  },
  {
    question: "What is React Native app development?",
    answer: `<p>React Native blends the best parts of native development with React, JavaScript library for developing user interfaces. You can use React Native now in your existing Android and iOS projects or you can build a whole new app from the very beginning.</p> `,
  },
  {
    question: "Is React Native enough for app development?",
    answer: `<p>React Native will assist you to swiftly create an MVP, both on iOS and Android. It speeds up mobile app development by up to 50% as related to native app development, so that startups can build functional MVPs in no time.</p> `,
  },
  {
    question: "What apps are developed using React Native?",
    answer: `<p>Majority of the apps are using React Native, from recognized Fortune 500 companies to hot new startups. Some renowned apps made on React Native include Facebook, Instagram, Pinterest, Airbnb, Skype, UberEATS, Tesla, Bloomberg, and many more.</p>`,
  },
  {
    question: "Why opt for React Native?",
    answer: `<p>React Native is arguably the best cross-platform mobile app development framework for developing iOS and Android apps using a single codebase. It's an open-source project backed by Facebook and trusted by thousands of corporate businesses globally. Exceptional performance, native touch, low development cost, and short turnaround times are why you should choose React Native for app development.</p>`,
  },
  {
    question: "How much does it cost to build a React Native mobile app?",
    answer: `<p>The cost of developing a React Native mobile app can change depending on difficulty, aspects, and layout. TekRevol offers modified quotes after evaluating your requirements. Contact us for a free comprehensive consultation and a customized estimation for your project requirements.</p>`,
  },
  {
    question: "How do you hire a React Native app development company?",
    answer: `<p>To hire a React Native app development company in UAE or any other country in GCC region, any business, startup, or aspiring individual should adhere to the following steps:</p>
    <ul>
    <li>Research: Search for companies with experience in React Native</li>
    <li>Portfolio Evaluation: Check their portfolio for applicable ventures</li>
    <li>Client Testimonials: Go through client testimonials and analyses</li>
    <li>Communication: Assess their communication and partnership processes</li>
    <li>Cost Estimation: Ask for a detailed cost estimate for your app venture</li>
    </ul>`,
  },
  {
    question: "Should I learn ReactJS or React Native?",
    answer: `<p>ReactJS is a good choice for projects that need high-performance storage, such as dynamic web apps. React Native is a preferred choice for projects that need to be able to scale easily.</p>`,
  },
  {
    question: "How long does it take to develop a React Native app?",
    answer: `<p>It can typically take 2 to 3 months, depending on the client's app's complexity and the required integration features.</p>`,
  },
  {
    question: "Can existing mobile apps be migrated to React Native?",
    answer: `<p>It can typically take 2 to 3 months, depending on the client's app's complexity and the required integration features.</p>`,
  },
  {
    question: "Is React a front end or backend?",
    answer: `<p>React is a front-end JavaScript library. React is capable of making API calls (sending the request to the backend), which deal with the data. However, React cannot process the database or the data source by itself.</p>`,
  },
  {
    question:
      "How does React Native guarantee a smooth user experience across platforms?",
    answer: `<p>React Native compiles native code, warranting near-native performance and a reliable user experience across iOS and Android platforms. Combined with a rich ecosystem of pre-built components, this ability underwrites an effortless and receptive app interface.</p>`,
  },
  {
    question: "Do any major enterprises and businesses use React Native?",
    answer: `<p>Facebook tops the list of top 10 global companies that are using the Native React framework. It is natural for Facebook to use the framework to develop their application as they have created the framework themselves. Facebook used the React Native framework to build its applications for both Android and iOS.</p>`,
  },
  {
    question:
      "What constant support and maintenance services does TekRevol offer for React Native apps?",
    answer: `<p>TekRevol provides complete support and maintenance services for React Native apps, guaranteeing unceasing updates, bug fixes, and optimizations. Our hardworking team is dedicated to keeping your app working efficiently and updated with the latest industry standards.</p>`,
  },
  {
    question: "Is React full stack?",
    answer: `<p>React is one such front-end library that can develop engaging user interfaces. Full stack react development refers to utilizing React as a Front-end Development framework with a backend based on frameworks such as Node. js or Python.</p>`,
  },
  {
    question: "Why choose TekRevol for React native app development?",
    answer: `<p>TekRevol stands out for React Native app development for the following reasons:</p>
    <ul>
    <li>Expertise: Our skilled developers guarantee high-quality solution</li>
    <li>Innovation: We utilize the latest technologies for state-of-the-art apps</li>
    <li>Transparency: We uphold transparent communication and project visibility</li>
    <li>Cost-Efficiency: Our pricing models guarantee value for your investment</li>
    <li>Support: TekRevol offers constant support and maintenance for enduring success</li>
    </ul>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
